<template>
  <Datatable :total="orderDetailBonuses.meta.page.total" :perPage="orderDetailBonuses.meta.page.perPage"
    :currentPage="orderDetailBonuses.meta.page.currentPage" @pagechanged="onChangePage" :columns="[
      { id: 'order_code', name: 'No Faktur' },
      { id: 'reguler_qty', name: 'Jumlah Reguler' },
      { id: 'free_qty', name: 'Jumlah Promo' },
      { id: 'follow_up_qty', name: 'Jumlah Promo Susulan' },
    ]">
    <template #tbody="{ classes }">
      <tr v-for="orderDetailBonus in orderDetailBonuses.data" :key="orderDetailBonus.id" :class="classes.tr">
        <td :class="classes.td">{{ orderDetailBonus.attributes.order_origin_code }} / {{
          orderDetailBonus.attributes.order_destination_code }}</td>
        <td :class="classes.td">{{ orderDetailBonus.attributes.regular_stock_remaining_qty | toCurrency }}</td>
        <td :class="classes.td">{{ orderDetailBonus.attributes.free_stock_remaining_qty | toCurrency }}</td>
        <td :class="classes.td">{{ (orderDetailBonus.attributes.regular_stock_remaining_qty > 0 || orderDetailBonus.attributes.free_stock_remaining_qty > 0) ? 0 : orderDetailBonus.attributes.bonus_packed | toCurrency }}</td>
      </tr>
    </template>
  </Datatable>
</template>

<script>
import { requestMixin } from '../../mixins/request/request';

export default {
  mixins: [requestMixin],
  props: {
    stockId: String
  },
  data() {
    return {
      orderDetailBonuses: {
        data: [],
        meta: {
          page: {}
        }
      }
    }
  },
  methods: {
    async loadOrderDetailBonuses(params) {
      const [res, err] = await this.request(`/api/v1/stocks/${this.stockId}/order-detail-bonuses`, {
        params: {
          'filter[has_bonus_remaining]': true,
          'page[size]': 5,
          ...params
        }
      })

      if (!err) {
        this.orderDetailBonuses = res
      }
    },
    onChangePage(page) {
      this.loadOrderDetailBonuses({ 'page[number]': page })
    }
  },
  created() {
    this.loadOrderDetailBonuses()
  }
}
</script>